const isProd = process.env.NODE_ENV === 'production';

const logger = {
  error: (...args) => console.error(...args),
  critical: (...args) => console.log(...args),
  info: (...args) => { if (!isProd) console.log(...args); },
  debug: (...args) => { if (!isProd) console.log(...args); },
  warn: (...args) => { if (!isProd) console.warn(...args); }
};

export default logger;
